import { create } from "zustand";

interface LoadingStoreType {
  completeLoadingState: boolean;
  loadingMessage: string;
  loadingParentRef: React.RefObject<HTMLElement> | null;
  loadingCount: number;

  completeLoading: (message: string) => void;
  setCompleteLoadingState: (visible: boolean) => void;
  setLoadingParentRef: (ref: React.RefObject<HTMLElement> | null) => void;
  startLoading: (message?: string) => void;
  stopLoading: () => void;
  updateMessage: (message: string) => void;
}

const useLoadingStore = create<LoadingStoreType>((set) => ({
  loadingCount: 0,
  completeLoadingState: false,
  loadingMessage: "",
  loadingParentRef: null, // 추가된 상태

  completeLoading: (message: string) => {
    set((state) => ({
      loadingCount: Math.max(state.loadingCount - 1, 0),
      completeLoadingState: true,
      loadingMessage: message,
    }));
  },
  setCompleteLoadingState: (visible: boolean) => {
    set({ completeLoadingState: visible });
  },
  setLoadingParentRef: (ref: React.RefObject<HTMLElement> | null) => {
    set({ loadingParentRef: ref });
  },
  startLoading: (message?: string) => {
    set((state) => ({
      loadingCount: state.loadingCount + 1,
      loadingMessage: message || state.loadingMessage,
      completeLoadingState: false,
    }));
  },
  stopLoading: () => {
    set((state) => ({
      loadingCount: Math.max(state.loadingCount - 1, 0),
    }));
  },
  updateMessage: (message: string) => {
    set((state) => (state.loadingCount ? { loadingMessage: message } : state));
  },
}));

export default useLoadingStore;
